import React, { useState, useRef, useEffect } from 'react';
import { arrayHasItems } from '../../helpers/common';

export const ShipmentSelect = ({ options, handleChange, placeholder = 'Select a PO', testId, selectedOption: externalSelectedOption }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [search, setSearch] = useState('');
  const [filteredOptions, setFilteredOptions] = useState(options);
  const [selectedOption, setSelectedOption] = useState(null);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const newFilteredOptions = options?.filter((option) =>
      option.title.toLowerCase().includes(search.toLowerCase())
    );
    setFilteredOptions(newFilteredOptions);
  }, [search, options]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // Sync controlled selected option from parent
  useEffect(() => {
    if (externalSelectedOption !== undefined) {
      setSelectedOption(externalSelectedOption);
    }
  }, [externalSelectedOption]);

  const handleOptionClick = (option) => {
    setSelectedOption(option);
    handleChange?.(option);
    setIsOpen(false);
    setSearch('');
  };

  return (
    <div className="relative w-64" ref={dropdownRef} data-testid={testId}>
      <button
        onClick={() => setIsOpen((prev) => !prev)}
        type="button"
        data-testid={testId ? `open-button-${testId}` : undefined}
        className="w-full px-4 py-2 text-left bg-white border border-gray-300 rounded-md shadow-sm focus:ring focus:ring-blue-300"
      >
        {options?.find((option) => option.value === selectedOption)?.title || placeholder}
      </button>

      {isOpen && (
        <div className="absolute z-10 w-full mt-2 bg-white border border-gray-300 rounded-md shadow-lg">
          <input
            type="text"
            value={search}
            data-testid={testId ? `search-${testId}` : undefined}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Search..."
            className="w-full px-4 py-2 border-b border-gray-200 focus:outline-none"
          />
          <ul className="max-h-48 overflow-y-auto">
            {arrayHasItems(filteredOptions) ? (
              filteredOptions.map((option, index) => (
                <li
                  key={index}
                  onClick={() => handleOptionClick(option.value)}
                  className="px-4 py-2 cursor-pointer hover:bg-blue-100"
                >
                  {option.title}
                </li>
              ))
            ) : (
              <li className="px-4 py-2 text-gray-500">No results found</li>
            )}
          </ul>
        </div>
      )}
    </div>
  );
};